<template>
  <el-dialog
    :title="typeof team.id !== 'undefined' ? 'Edit Team' : 'Create New Team'"
    visible
    top="5vh"
    :close-on-click-modal="false"
    @close="$emit('update:isShow', false)"
  >
    <el-form
      ref="teamEditForm"
      v-loading="isSaving"
      :label-position="'top'"
      :rules="rules"
      label-width="100px"
      :model="team"
    >
      <el-row :gutter="15">
        <el-col :md="12">
          <el-form-item
            label="Name"
            prop="name"
          >
            <el-input
              v-model="team.name"
              placeholder="e.g. Head Office, Suburb Branch, etc"
              :disabled="!!team.id"
              clearable
            />
          </el-form-item>
        </el-col>

        <el-col :md="12">
          <el-form-item
            label="Code"
            prop="code"
          >
            <el-input
              v-model="team.code"
              placeholder="e.g. HEADOF, SUBURB, BRANCH, etc"
              clearable
            />
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col :md="24">
          <el-form-item
            label="Description"
            prop="description"
          >
            <el-input
              v-model="team.description"
              placeholder="Team Description"
              clearable
            />
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col :md="24">
          <el-form-item label="Platform">
            <el-switch
              v-model="team.open360_only"
              :disabled="team.open360_only && !team.modified"
              inactive-text="OpenFreight"
              active-text="Open360"
            />
            <br>
            <span
              v-if="team.open360_only"
              class="text-muted"
            >
              This cannot be reversed. This team will only have access to Open360 and will not be able to access OpenFreight.
            </span>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <span
      slot="footer"
      class="dialog-footer"
    >
      <el-button @click.native="$emit('update:isShow', false)">
        Cancel
      </el-button>
      <el-button
        :loading="isSaving"
        type="primary"
        @click.native="typeof team.id !== 'undefined' ? updateTeam() : createTeam()"
      >
        {{ typeof team.id !== 'undefined' ? 'Save' : 'Create' }}
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  props: {
    team: {
      type: Object,
      required: true
    },
    accountId: {
      type: String,
      required: true
    },
    isShow: {
      type: Boolean,
      required: true
    }
  },
  data () {
    return {
      isSaving: false,
      rules: {
        name: [
          { required: true, message: 'Please input team name', trigger: 'blur' },
          { max: 85, message: 'Length not more than 85', trigger: 'blur' }
        ],
        code: [
          { required: true, message: 'Please input team code', trigger: 'blur' },
          { min: 6, max: 6, message: 'Length of code must be 6', trigger: 'blur' }
        ]
      }
    }
  },
  watch: {
    'team.name': function (name) {
      let code = ''

      if (name.length) {
        name = name.split(' ')

        if (name.length < 7) {
          const characters = Math.ceil(6 / name.length)

          name.map(segment => {
            code += segment.substring(0, characters)
          })
        } else {
          code = name[0].substring(0, 6)
        }

        code = code.toUpperCase().substring(0, 6)
      }

      this.team.code = code
    }
  },
  methods: {
    createTeam () {
      this.$refs.teamEditForm.validate((valid) => {
        if (valid) {
          this.isSaving = true
          this.$sdk.team.create(this.team, builder => {
            builder.context = { resource: 'account', id: this.accountId }
          })
            .then(() => this.$message({ message: 'Successfully saved', type: 'success' }))
            .finally(() => {
              this.isSaving = false
              this.$emit('saved')
              this.$emit('update:isShow', false)
            })
        }
      })
    },
    updateTeam () {
      this.$refs.teamEditForm.validate((valid) => {
        if (valid) {
          this.isSaving = true
          this.team.update(builder => {
            builder.context = { resource: 'account', id: this.accountId }
          })
            .then(() => this.$message({ message: 'Successfully saved', type: 'success' }))
            .finally(() => {
              this.isSaving = false
              this.$emit('saved')
              this.$emit('update:isShow', false)
            })
        }
      })
    }
  }
}
</script>
